import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import parse from 'html-react-parser'; 
import GLOBAL_CONFIG from '../../config/config'; 
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle, navParticipationMenu, scrollToElement } from '../../modules/helpers';
import GiftContent from '../../components/Content/GiftContent/GiftContent';
import ValidateForm from '../../modules/validate';     
import { NavLink, Route } from 'react-router-dom/cjs/react-router-dom.min';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
import ReCaptcha from 'react-google-invisible-recaptcha';         
import _LOCAL_CAPTCHA from '../../Models/Captcha';
import GiftContentFooter from '../../components/Content/GiftContent/GiftContentFooter';
import CampaignServices from '../../Services/Campaign';

class ThankYou extends Component {
  //huhu

  constructor(props){
    super(props);
    this.state = {
      isMobile: false,
      name: null,
      iban: null,
      entryid: null,
      source: null,
      errorName: false,
      errorIban: false,
      formSubmitted: false,
      isTerms: false,
      showCheckboxError: false,
      errorMessage: "",
      loaderSubmit: false
    };
    this.resize = this.resize.bind(this);
    this.TriggerCaptcha = this.TriggerCaptcha.bind(this);

  }
  resize() {
    // set isMobile to true if the device is a mobile and false otherwise 
    this.setState({ isMobile: window.innerWidth <= 768 });
  }
    componentWillMount(){
      // if (sessionStorage.getItem(GLOBAL_CONFIG.Session.userstatus) === null) {
      //   //Go to particaption page
      //   this.props.history.push({ pathname: GLOBAL_CONFIG.Route.home });
      // }
      //    else {
      //   sessionStorage.removeItem(GLOBAL_CONFIG.Session.userinfo)
      //   }

      window.addEventListener("resize", this.resize);
      this.resize();
    }

    componentDidMount(){
        const { t } = this.props;
        //Active menu participation - mitmachen
        // navParticipationMenu(true);

        const currentUrl = window.location.href;

        
        if (currentUrl.includes("gewinne")) {
          
          const queryString = currentUrl.split("?")[1];
      
          // Initialize variables
          let pid = null;
          let cid = null;
      
          if (queryString) {
            const pidIndex = queryString.indexOf("pid=");
            if (pidIndex !== -1) {
              let pidValue = queryString.substring(pidIndex + 4); 
              
              
              const cidIndex = pidValue.indexOf("cid=");
              if (cidIndex !== -1) {
                pid = pidValue.substring(0, cidIndex); 
                cid = pidValue.substring(cidIndex + 4); 
              } else {
                pid = pidValue; 
              }
            }
          }
      
          // Trim any trailing ampersands or spaces
          if (pid) pid = pid.replace(/&.*/, "").trim();
          if (cid) cid = cid.replace(/&.*/, "").trim();
      
          // Log values
          console.log("Extracted PID:", pid);
          console.log("Extracted CID:", cid);
      
          // Store in localStorage if values exist
          if (pid) localStorage.setItem("ParticipationId", pid);
          if (cid) localStorage.setItem("Consumerid", cid);
          this.getParticipant(pid, cid)
      
          // Update state
          this.setState({ pid, cid });

          if (pid === null || cid === null) {
            this.props.history.push({ pathname: GLOBAL_CONFIG.Route.home });
          }
        }
        //Scroll to navigation menu
        // scrollToElement();
        window.scrollTo(0, 0);
        //Remove main loader
        mainLoaderToggle('hide');

        const storedData = localStorage.getItem('participationData');
        let newState = {}

        if (storedData) {
          const parsedData = JSON.parse(storedData);
          newState = {
            firstname: parsedData.data?.Firstname || "",
            lastname: parsedData.data?.Lastname || "",
            email: parsedData.data?.Email || "", 
            entryid: parsedData.data?.ParticipationId || "" , 
            consumerid: parsedData.data?.Consumerid || ""
          }

        }

        //Virtual page
        appGoogleTracking.dataLayerPush({
            'customEvent': {
                'event': 'virtual-page',
                'virtualUri': GLOBAL_CONFIG.Route.thankyou,
                'pageTitle': t('Meta.title'),
                'ParticipantId' : window.PARTICIPATION_ID
            }
        });

        newState.winTier = localStorage.getItem('winTier');
        newState.retailer = localStorage.getItem('retailer');
        this.setState(newState);
    }

    componentWillUnmount(){
        mainLoaderToggle('show');
    }

    getParticipant(pid, cid) {
      CampaignServices.CheckParticipant(pid, cid)
        .then((response) => {
          let {success, message, data} = response.data
          if (success) {
            localStorage.setItem('FirstName', data.Firstname)
            localStorage.setItem('LastName', data.Lastname)
            localStorage.setItem('Email', data.Email)
          } else {
            this.props.history.push({ pathname: GLOBAL_CONFIG.Route.home });
          }
        })
    }

    googleTag = (event, category, action, label) => {
      appGoogleTracking.dataLayerPush({
          'dataEvent': event,
          'dataCategory': category,
          'dataAction': action,
          'dataLabel': label
      })
  }

  handleCheckboxChange = (e) => {
    const isTerms = e.target.checked;
    this.setState({ isTerms });
  
    // Show error if user unchecks the checkbox
    if (!isTerms) {
      this.setState({ showCheckboxError: true });
    } else {
      this.setState({ showCheckboxError: false });
    }
  };

    render() { 
      console.log(this.props)
        const { t } = this.props;
        const { winTier, retailer } = this.state;
        console.log('winTier', winTier);
      let image = {
        desktop: t('Page.Confirmation.bottomBanner.desktop'),
        mobile: t('Page.Confirmation.bottomBanner.mobile')
      };  

      let _captcha = _LOCAL_CAPTCHA['gluecksrad'];

        return (

          
          <div className={`content-iban content-confirmation__${window.PROMOTION_CAMPAIGN}`}>  
          {
                this.state.loaderSubmit ?
                    <div className="simple-loader__container active">
                        <div className="simple-loader__indicator"></div>
                    </div>
                    : null
            }
              <div className='confirmation-title'>
              <picture>
                  <source srcSet={parse(t('Page.Confirmation.title.desktop.iban'))} media='(min-width: 481px)'/>
                  <img src={parse(t('Page.Confirmation.title.mobile.iban'))} alt='win-title'/>
                </picture>
                <p className='confirmation-subtitle'>{parse(t('Page.Confirmation.subTitle.iban'))}</p>
              </div>
              <div className='iban-email'>
                  <div className='text-iban'>
                    <div className='iban'>
                      <form
                        id='iban-form'
                        name='iban-form'
                        method='post'
                        action='/'
                        onSubmit={this.onSubmitHandler.bind(this)} noValidate
                      >
                        <div className='form-container' id='iban-details'>
                        <p>Pflichtfelder*</p>
                        <div id="name" className="input-container">
                          <div className="form-input__container">
                              {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Label}</label> */}
                              <input className="form-input__input js-event-type-in js-event-ab"
                                  type={t("Page.Confirmation.prize.einkauf.iban.Name.Type")}
                                  name={t("Page.Confirmation.prize.einkaufiban..Name.Id")}
                                  id={t("Page.Confirmation.prize.einkauf.iban.Name.Id")}
                                  placeholder={t("Page.Confirmation.prize.einkauf.iban.Name.Label")}
                                  data-require={t("Page.Confirmation.prize.einkauf.iban.Name.Required")}
                                  data-error-target={`#error-${t("Page.Confirmation.prize.einkauf.iban.Name.Id")}`}
                                  data-regex-pattern="^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðß ,.'-]+$"
                                  data-type="regex"
                                  data-required-message=""
                                  data-pattern-message=""
                                  data-event-fieldname="Firstname"
                                  data-event="form-click"
                                  data-category="Form Action"
                                  data-action="Firstname"
                                  data-label="Type In"
                                  ref={input => this._DETAILS_name= input}
                                  onBlur={(event) => {
                                    if (!this._DETAILS_name.value) {
                                      this.setState({ errorName: true })
                                      event.target.classList.add("notvalid");
                                      event.target.classList.remove("valid");
                                    } else {
                                      this.setState({ errorName: false })
                                      event.target.classList.add("valid");
                                      event.target.classList.remove("notvalid");
                                    }
                                  }}
                              />
                          </div>
                        </div>
                        <div id="iban" className="input-container">
                            <div className="form-input__container">
                                {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Label}</label> */}
                                <input className="form-input__input js-event-type-in js-event-ab"
                                    type={t("Page.Confirmation.prize.einkauf.iban.iban.Type")}
                                    iban={t("Page.Confirmation.prize.einkauf.iban.iban.Id")}
                                    id={t("Page.Confirmation.prize.einkauf.iban.iban.Id")}
                                    placeholder={t("Page.Confirmation.prize.einkauf.iban.iban.Label")}
                                    data-require={t("Page.Confirmation.prize.einkauf.iban.iban.Required")}
                                    data-error-target={`#error-${t("Page.Confirmation.prize.einkauf.iban.iban.Id")}`}
                                    data-regex-pattern="^AT\d{18}$"
                                    data-type="regex"
                                    data-required-message=""
                                    data-pattern-message=""
                                    maxLength={20}
                                    data-event-fieldname="Firstname"
                                    data-event="form-click"
                                    data-category="Form Action"
                                    data-action="Firstname"
                                    data-label="Type In"
                                    ref={input => this._DETAILS_iban = input}
                                    onBlur={(event) => {
                                      if (!this._DETAILS_iban.value) {
                                        this.setState({ errorIban: true })
                                        event.target.classList.add("notvalid");
                                        event.target.classList.remove("valid");
                                      } else {
                                        this.setState({ errorIban: false })
                                        event.target.classList.add("valid");
                                        event.target.classList.remove("notvalid");
                                      }
                                    }}
                                />
                            </div>
                        </div>

                       <div className="input-container">
                       <label htmlFor="terms" className={`custom-inputs ${this.state.showCheckboxError ? "error-checkbox" : ""}`}>
                            <span className="text-content">
                            Ich habe die&nbsp;
                            <NavLink to={GLOBAL_CONFIG.Route.terms} exact data-event="click_conditions_register_now" data-category="Cash Win Page" data-action="Click on Conditions" data-label="ENG_CW_PART" onClick={appGoogleTracking.processEventCTANavLink}>Teilnahmebedingungen</NavLink> 
                              &nbsp;gelesen und akzeptiert.*<br />
                              {this.state.showCheckboxError && (
                                <p className='error-terms-iban'>Bitte akzeptiere die Teilnahmebedingungen, um fortzufahren.</p>
                              )}
                            </span>
                            <input
                              type="checkbox"
                              id="terms"
                              checked={this.state.isTerms}
                              onChange={this.handleCheckboxChange}
                              onClick={() => this.googleTag('click_conditions_join_now', 'Cash Win Page', 'Click on Conditions', 'ENG_CW_PART')}
                            />
                            <span className='checkmark'></span>
                          </label>
                        </div>

                        <button type="submit" className="btn__container btn--primary btn__margin submit"
                            onClick={() => {
                                // this.googleTag('join_now', 'Start Page', 'Click on Join Now', 'EASTER_SP_PART')
                                // this.scroll();
                            }
                            }>
                            FORMULAR ABSENDEN
                        </button>

                        <div className="form-container centered" style={{display: 'none'}}>
                          <ReCaptcha
                              ref={ref => this._CAPTCHA = ref}
                              locale={_captcha.lang}
                              sitekey={_captcha.key}
                              onResolved={this.onResolved}
                          />
                        </div>

                        </div>
                      </form>
                      {
                        this.state.errorMessage && (
                          <div>
                            <p style={{margin: 'auto'}}className='error-message-iban'>
                              {this.state.errorMessage}
                            </p>
                          </div>
                        )
                      }
                  </div>
                  
                  </div>
                  
              </div>
              <div className="content-participation-footer" style={{paddingTop: '0'}}>
                <div className="content-gift-footer">
      
                    <div className="content-faq s-content-copy marge-bottom">
                        <div className="s-content-copy__item footer">
                            <p className="headings">HAST DU NOCH FRAGEN ZUM GEWINNSPIEL?</p>
                              <p style={{ fontSize: '20px', marginTop: '25px' }}>
                                    <NavLink to={GLOBAL_CONFIG.Route.faq} target="_blank" exact data-event="go_to_faq_link" data-category="Cash Win Page" data-action="Click on Link" data-label="GAME_CW_PART" onClick={appGoogleTracking.processEventCTANavLink}>
                                        Hier
                                    </NavLink> geht's zu den FAQ.
                                </p>
                        </div>
                    </div>
                </div>
              </div>
          </div>

        );
    }

    onSubmitHandler(e) {
      e.preventDefault();
          

      let validateForm = ValidateForm.validateForm('iban-form');

      if (validateForm ===  true) {
        if (!this.state.isTerms) {
          this.setState({ showCheckboxError: true });
          return;
        }
        this.TriggerCaptcha();
        this.setState({loaderSubmit: true})
      } else {
        const errorField = document.querySelector('.notvalid');
        if (errorField) {
            errorField.focus();
            if (!this.state.isTerms) {
              this.setState({ showCheckboxError: true });
              return;
            }
        }
        const errorFile = document.querySelector(".form-input__error.js-file-error.active");
        if (errorFile) {
            errorFile.focus();
            if (!this.state.isTerms) {
              this.setState({ showCheckboxError: true });
              return;
            }
        }
      }
    }

    TriggerCaptcha() {
      //Process captcha - after which form ajax will be handle
      if (this._CAPTCHA.getResponse() !== '') {
          this._CAPTCHA.reset();
      }
      this._CAPTCHA.execute();
    }

    onResolved = (token) => {
      //Process form
      this.ProcessFormData(token);
      // alert('resolve')
    }

    ProcessFormData(token, event) {
      console.log('1');

      let validateForm = ValidateForm.validateForm("iban-form")
      if (validateForm === true) {
        this.setState({
          loaderSubmit: true,
        })

        const firstname = localStorage.getItem('FirstName')
        const lastname = localStorage.getItem('LastName')
        const email = localStorage.getItem('Email')
        const entryid = localStorage.getItem('ParticipationId')
        const consumerid = localStorage.getItem('Consumerid')
  
        console.log('firstname', firstname);
        console.log('lastname', lastname);
        console.log('email', email);
        console.log('entryid', entryid);
        console.log('consumerid', consumerid);
  
        let data = {
          firstname,
          lastname,
          email,
          entryid,
          consumerid,
          accountname: this._DETAILS_name.value,
          iban: this._DETAILS_iban.value,
          recaptcha: token,
          source: 'email'
        }
  
        console.log('data', data);
  
        if (window.PROMOTION_CAMPAIGN === 'gluecksrad') {
          let _data = new FormData();
  
          for (let key in data) {
            _data.append(key, data[key]);
          }
  
          CampaignServices.Iban({
            data: _data,
          })
            .then((response) => {
              console.log('response', response);
  
              let {success, message, data} = response.data
  
              if (success) {
                appGoogleTracking.dataLayerPush({
                  dataEvent: "submit_form",
                  dataCategory: "Cash Win Page",
                  dataAction: "Click on Submit Form",
                  dataLabel: "ENG_CW_OTHER",
                });
                this.setState({ formSubmitted: true });
                 this.props.history.push({pathname: GLOBAL_CONFIG.Route.ibanConfirm})
              } else {
                let errorMessage = ""
                if (this._DETAILS_name) this._DETAILS_name.value = "";
                if (this._DETAILS_iban) this._DETAILS_iban.value = "";
                let errorStatus = data.Error[0];
                if (!!errorStatus) {
                  this.setState({
                    loaderSubmit: false,
                  })
                  switch (errorStatus) {
                    case "ALREADY_SUBMITTED":
                      errorMessage = "Bereits eingereicht";
                      break;
                    case "AN_ERROR_HAS_OCCURED":
                      errorMessage = "Es ist ein Fehler aufgetreten";
                      break;
                    case "CAPTCHA_ERROR":
                      errorMessage = "CAPTCHA FEHLER";
                      break;
                    default: 
                      errorMessage = "Es ist ein Fehler aufgetreten";
                      break;
                  }
                }
                this.setState({
                  loaderSubmit:false,
                  errorMessage
                })
                
              }
            })
            .catch((error) => {
              let { Data } = error.response.data,
              errorStatus = Data.Error[0] || "";
              this.ProcessError(errorStatus);
            });

        } else {
          if ( this.state.errorName|| this.state.errorIban) {
            event.target.classList.add("notvalid");
            event.target.classList.remove("valid");
          }
        }
      }
    }

    ProcessError(_ERR) {
      this.setState({
        loaderSubmit: false,
        loaderGeneralError: true,
        genericErrorMessage: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
      });
    }

}

export default withTranslation()(ThankYou);
